import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  useTheme,
  } from '@mui/material';
import provinceData from '../../config/province.json';
import districtData from '../../config/district.json';
import { optionProfile } from '../../constant/Constants';
import SaveIcon from '@mui/icons-material/Save';
import EditIcon from '@mui/icons-material/Edit';
import Color from '../../layouts/Color';
import FontSize from '../../layouts/FontSize';

const buttonStyle = {
  cursor: 'default', 
  fontSize: FontSize.Big, 
  color: Color.Main, 
  '&:hover':  {
   background: Color.Button, color: Color.Dangerous 
 }
};
const boxStyle = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column'
};
const buttonSave = {
  color: Color.Button,
  backgroundColor: Color.Main,
  '&:hover': { background: Color.Button, color: Color.Main }
};
const marginStyle = {mt:2};
const boxBtnStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  p: 2
};

export const UpdateCardAddress = (props) => {
  const theme = useTheme()

  const [values, setValues] = useState({
    details: 'Tổ dân phố Nghĩa Lộ, phường Phùng Chí Kiên',
    district: ' thị xã Mỹ Hào',
    province: 'tỉnh Hưng Yên',
    country: 'VIETNAM',
  });

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  return (
    <form>
      <Card>
      <CardHeader
          title={<Box sx={boxStyle}>
            <Button
              id="update-card-address"
              sx={buttonStyle} 
              endIcon={<EditIcon />}>
               Update  Profile
            </Button>
          </Box>
          } />
        <Divider sx={marginStyle} />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Country"
                name="country"
                onChange={handleChange}
                required
                value={values.country}
                variant="outlined"
                sx={{
                  '& .MuiInputBase-input': {
                    bgcolor: theme.palette.background.default
                },
                '& .MuiOutlinedInput-root': {
                    bgcolor: theme.palette.background.default
                },
                }}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Select Province"
                name="province"
                onChange={handleChange}
                required
                select
                SelectProps={{ native: true }}
                value={values.province}
                variant="outlined"
                sx={{
                  '& .MuiInputBase-input': {
                    bgcolor: theme.palette.background.default
                },
                '& .MuiOutlinedInput-root': {
                    bgcolor: theme.palette.background.default
                },
                }}
              >
                {provinceData.provinces.map((option) => (
                  <option
                    key={option.id}
                    value={option.province}
                  >
                    {option.province}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Select District"
                name="district"
                onChange={handleChange}
                required
                select
                SelectProps={{ native: true }}
                value={values.district}
                variant="outlined"
                sx={{
                  '& .MuiInputBase-input': {
                    bgcolor: theme.palette.background.default
                },
                '& .MuiOutlinedInput-root': {
                    bgcolor: theme.palette.background.default
                },
                }}
              >
                {districtData.districts.map((option) => (
                  <option
                    key={option.id}
                    value={option.district}
                  >
                    {option.district}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Select Commune"
                name="commune"
                onChange={handleChange}
                required
                select
                SelectProps={{ native: true }}
                value={values.district}
                variant="outlined"
                sx={{
                  '& .MuiInputBase-input': {
                    bgcolor: theme.palette.background.default
                },
                '& .MuiOutlinedInput-root': {
                    bgcolor: theme.palette.background.default
                },
                }}
              >
                {districtData.districts.map((option) => (
                  <option
                    key={option.id}
                    value={option.district}
                  >
                    {option.district}
                  </option>
                ))}
              </TextField>
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                fullWidth
                label="Details Address"
                name="country"
                onChange={handleChange}
                required
                value={values.details}
                variant="outlined"
                sx={{
                  '& .MuiInputBase-input': {
                    bgcolor: theme.palette.background.default
                },
                '& .MuiOutlinedInput-root': {
                    bgcolor: theme.palette.background.default
                },
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
        <Box sx={boxBtnStyle}>
          <Button
            sx={buttonSave}
            variant="contained"
            endIcon={<SaveIcon fontSize="small"></SaveIcon>}
            onClick={() => {
              props.update(optionProfile.DEFAULT);
            }}
          >
            Save
          </Button>
        </Box>
      </Card>
    </form>
  );
};
